export default "__VITE_ASSET__ed388c79__"